export default function initComparisonTableLogic() {
	const initComparisonTableInstance = () => {
		document.querySelectorAll(".comparisonTable:not(.comparisonTable--setUp)").forEach(comparisonTableElement => {
			comparisonTableElement.classList.add("comparisonTable--setUp");

			const metadataKeys: string[] = comparisonTableElement.getAttribute("data-metadata-keys")?.split(",") ?? [];

			{ // Handles toggling between viewing icons and text for the entries
				let viewTextState = false;

				const viewTextToggles = comparisonTableElement.querySelectorAll(".comparisonTable__viewTextToggle");
				viewTextToggles.forEach(toggleElement => {
					toggleElement.addEventListener("click", evt => {
						viewTextState = !viewTextState;
						viewTextToggles.forEach(ele => {
							ele.firstChild.nodeValue = viewTextState
								? ele.getAttribute("data-icon")
								: ele.getAttribute("data-text");
						});
						comparisonTableElement.querySelectorAll(".comparisonTable__entry").forEach(cte => {
							const icons = cte.querySelectorAll(".comparisonTable__entryIcon");
							const names = cte.querySelectorAll(".comparisonTable__entryName");
							if (viewTextState) {
								if (names.length > 0) {
									icons.forEach(ele => (ele as HTMLElement).style.setProperty("display", "none"));
								}
								names.forEach(ele => (ele as HTMLElement).style.removeProperty("display"));
							} else {
								if (icons.length > 0) {
									names.forEach(ele => (ele as HTMLElement).style.setProperty("display", "none"));
								}
								icons.forEach(ele => (ele as HTMLElement).style.removeProperty("display"));
							}
						});
					});
				});
			}

			{ // Handles "searching" entries
				let mostRecentText = "";

				const allFilters = comparisonTableElement.querySelectorAll(".comparisonTable__filter");

				const matchingEntry = (comparisonTableEntry: Element) => {
					return metadataKeys.map(metadataKey => "data-metadata-entry-" + metadataKey)
								.map(attr => comparisonTableEntry.getAttribute(attr) ?? "")
								.reduce((a: boolean, value: string) => a || value.indexOf(mostRecentText) !== -1, false);
				};

				const updateVisibleEntrys = (filterText: string) => {
					if (filterText.toLowerCase() !== mostRecentText) {
						mostRecentText = filterText.toLowerCase();

						allFilters.forEach(otherFilter => {
							if (otherFilter !== event.target && (otherFilter as HTMLInputElement).value !== filterText) {
								(otherFilter as HTMLInputElement).value = filterText;
							}
						});

						comparisonTableElement.querySelectorAll(".comparisonTable__entry").forEach(comparisonTableEntry => {
							if (matchingEntry(comparisonTableEntry)) {
								(comparisonTableEntry as HTMLElement).style.removeProperty("display");
							} else {
								(comparisonTableEntry as HTMLElement).style.setProperty("display", "none");
							}
						});
					}
				};

				allFilters.forEach(filterElement => {
					filterElement.addEventListener("keyup", event => updateVisibleEntrys((filterElement as HTMLInputElement).value));
				});
				if (comparisonTableElement.querySelector(".comparisonTable__filter")){
					updateVisibleEntrys((comparisonTableElement.querySelector(".comparisonTable__filter") as HTMLInputElement).value);
				}
			}
		});
	};

	const initialSetup = () => {
		initComparisonTableInstance();
		new MutationObserver(initComparisonTableInstance).observe(document, {
			childList: true,
			subtree: true
		});
	}

	if (document.readyState === "complete" || document.readyState === "interactive") {
		initialSetup();
	} else {
		document.addEventListener("DOMContentLoaded", initialSetup);
	}
}